const environment = {
  production: false,
  environment: 'DEV',
  title: 'Dev Environment Heading',
  apiUrl: 'http://api-dev.noitada.app',
  firebaseWebConfig: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
};



export default environment;
